/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IBenefitAgePrice } from 'src/interfaces';
import BenefitsService from 'src/services/benefits.service';

export const usePatchBenefitAgePrice = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation((data: IBenefitAgePrice) => BenefitsService.patchBenefitAgePrice(data), {
    onSuccess: () => {
      AlertAdapter('Age price edited successfully', 'success');
      queryClient.invalidateQueries({ queryKey: ['benefits/prices'] });
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
  return mutation;
};
